import React from "react";

function Work({ position, company, location, type, duration }) {
  return (
    <article
      className="pt-8 pb-5
                 border-b border-white/20
                 transition-all duration-300
                 hover:border-purple-500"
    >
      {/* TOP ROW */}
      <div className="flex justify-between items-center">
        <h1 className="text-white md:text-lg lg:text-xl font-semibold">
          {position}
        </h1>

        <div className="bg-purple-600/20 text-purple-400 
                        text-xs rounded-3xl px-3 py-1 min-w-fit
                        border border-purple-500/40">
          {type}
        </div>
      </div>

      {/* DETAILS ROW */}
      <div className="flex justify-between pt-3">
        <div className="flex flex-col md:flex-row">

          {/* COMPANY */}
          <div className="flex items-center pr-5">
            <svg
              className="fill-white/80 hover:fill-purple-400 transition-colors min-w-fit"
              width="16"
              height="12"
              viewBox="0 0 16 12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M3.33331 1.5V10.5H7.33331V8.75H8.66665V10.5H12.6666V1.5H3.33331Z" />
            </svg>
            <p className="text-white/80 text-xs md:text-sm font-light pl-1">
              {company}
            </p>
          </div>

          {/* LOCATION */}
          <div className="flex items-center">
            <svg
              className="fill-white/80 hover:fill-purple-400 transition-colors min-w-fit"
              width="16"
              height="12"
              viewBox="0 0 16 12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.00001 11.25L3.78201 7.51912C2.8875 6.63817 2.50001 5.76871 2.50001 4.875C2.50001 3.78098 3.07947 2.73177 4.11092 1.95818C5.14237 1.1846 6.54132 0.75 8.00001 0.75C9.4587 0.75 10.8576 1.1846 11.8891 1.95818C12.9205 2.73177 13.5 3.78098 13.5 4.875C13.5018 5.7683 13.1127 6.63737 12.3925 7.34888L8.00001 11.25Z" />
            </svg>
            <p className="text-white/80 text-xs md:text-sm font-light pl-1">
              {location}
            </p>
          </div>
        </div>

        {/* DURATION */}
        <p className="text-white/70 text-xs md:text-sm font-light min-w-fit">
          {duration}
        </p>
      </div>
    </article>
  );
}

export default Work;
